import React, { forwardRef } from 'react';
import PrimaryActionButton from '../common/PrimaryActionButton';
import { LANDING_COLORS } from './landingTokens';

const TONE_SX = {
  accent: {
    background: LANDING_COLORS.terracotta,
    color: LANDING_COLORS.sand,
    boxShadow: '0 10px 24px rgba(161, 92, 67, 0.22)',
    '&:hover': { background: LANDING_COLORS.terracottaDeep },
  },
  light: {
    background: LANDING_COLORS.sand,
    color: LANDING_COLORS.navy,
    boxShadow: 'none',
    '&:hover': { background: LANDING_COLORS.paper },
  },
};

const LandingCtaButton = forwardRef(function LandingCtaButton({ tone = 'accent', sx, ...props }, ref) {
  const extraSx = Array.isArray(sx) ? sx : [sx];
  return (
    <PrimaryActionButton
      ref={ref}
      {...props}
      sx={[{ borderRadius: '10px', fontWeight: 600 }, TONE_SX[tone], ...extraSx]}
    />
  );
});

export default LandingCtaButton;
